@if (requisition) {
  <rt-requisitions-details-container
    [requisition]="requisition"
    [adminsMap]="adminsMap"
    [approvalFlow]="approvalFlow"
    [allApproversDeleted]="allApproversDeleted"
    [approversWithoutAccessCount]="approversWithoutAccessCount"
    [isDepartmentsMode]="isDepartmentsMode"
  ></rt-requisitions-details-container>
}
